/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Asset,
    AssetFromJSON,
    AssetFromJSONTyped,
    AssetToJSON,
    TapeFile,
    TapeFileFromJSON,
    TapeFileFromJSONTyped,
    TapeFileToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetBackup
 */
export interface AssetBackup {
    /**
     * 
     * @type {number}
     * @memberof AssetBackup
     */
    id: number;
    /**
     * 
     * @type {TapeFile}
     * @memberof AssetBackup
     */
    tapeFile: TapeFile;
    /**
     * 
     * @type {Asset}
     * @memberof AssetBackup
     */
    asset: Asset;
    /**
     * 
     * @type {string}
     * @memberof AssetBackup
     */
    readonly searchHighlight: string;
    /**
     * 
     * @type {string}
     * @memberof AssetBackup
     */
    customFieldsSnapshot?: string | null;
}

export function AssetBackupFromJSON(json: any): AssetBackup {
    return AssetBackupFromJSONTyped(json, false);
}

export function AssetBackupFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetBackup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'tapeFile': TapeFileFromJSON(json['tape_file']),
        'asset': AssetFromJSON(json['asset']),
        'searchHighlight': json['search_highlight'],
        'customFieldsSnapshot': !exists(json, 'custom_fields_snapshot') ? undefined : json['custom_fields_snapshot'],
    };
}

export function AssetBackupToJSON(value?: AssetBackup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'tape_file': TapeFileToJSON(value.tapeFile),
        'asset': AssetToJSON(value.asset),
        'custom_fields_snapshot': value.customFieldsSnapshot,
    };
}


